/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Cmp_CliInputs */

const en_pc_online_cmp_cli = /** @type {(inputs: Pc_Online_Cmp_CliInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Command line (pdfcraft-cli) and MCP server`)
};

const zh_pc_online_cmp_cli = /** @type {(inputs: Pc_Online_Cmp_CliInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`命令行（pdfcraft-cli）与 MCP 服务器`)
};

/**
* | output |
* | --- |
* | "Command line (pdfcraft-cli) and MCP server" |
*
* @param {Pc_Online_Cmp_CliInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_cmp_cli = /** @type {((inputs?: Pc_Online_Cmp_CliInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Cmp_CliInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_cmp_cli(inputs)
	return zh_pc_online_cmp_cli(inputs)
});
export { pc_online_cmp_cli as "pc.online.cmp.cli" }